import { useSyncExternalStore } from "react";

// In dark mode a message body is darkened to match the app (EmailBodyFrame); this is the person's choice to see
// messages in the sender's own colours instead. Kept in this browser only, like Outlook's "Switch background".

const KEY = "fg-mail-original-colours";
const listeners = new Set<() => void>();

function read(): boolean {
    try {
        return window.localStorage.getItem(KEY) === "1";
    } catch {
        return false;
    }
}

let original = read();

export function setOriginalColours(value: boolean): void {
    original = value;
    try {
        window.localStorage.setItem(KEY, value ? "1" : "0");
    } catch {
        /* storage blocked: the choice lasts until the page is closed */
    }
    listeners.forEach((l) => l());
}

/** True when messages should be shown in the sender's colours even in dark mode. */
export function useOriginalColours(): boolean {
    return useSyncExternalStore(
        (cb) => {
            listeners.add(cb);
            return () => listeners.delete(cb);
        },
        () => original,
        () => false
    );
}
